export default __webpack_public_path__ + "static/media/works.1e628326.mp4";